import { createContext } from 'react';

import type { State } from '#src/app/shared/utils/async';
import type { BraintreeClient, PaypalCheckout } from '#src/app/shared/utils/payments';

export type PaypalState = State<{
	paypalCheckout: PaypalCheckout;
	braintreeClientInstance: BraintreeClient;
	deviceData: string | undefined;
}>;

export const PaypalContext = createContext<PaypalState>({ status: 'loading' });
